import type { Options as ComponentOptions } from '@highcharts/dashboards/es-modules/Dashboards/Components/Component.js';
import type { DashboardQueryKey } from '@h20/contracts/types/api/dashboard/DashboardQueryCatalog';

/** The Dashboards component type the widget host is registered under. */
export const DASHBOARD_WIDGET_TYPE = 'DashboardWidget';

/** What a data-bound cell stores about its query, before a save compiles it to a connector. */
export type DashboardQueryBinding = {
    /** Which catalogue query feeds this cell. */
    queryKey?: DashboardQueryKey;
    /** The values the author typed into the query's parameter inputs, keyed by parameter name.*/
    queryParams?: Record<string, string | boolean>;
};

/**
 * Cell options for the `DashboardWidget` component type. The component is named by
 * string `widgetKey`, never a class reference, so options stay JSON-serialisable
 * and survive `board.getOptions()`. `widgetConfig` feeds the component's `config` input.
 */
export interface DashboardWidgetOptions<TConfig = Record<string, unknown>>
    extends ComponentOptions, DashboardQueryBinding {
    type: typeof DASHBOARD_WIDGET_TYPE;
    widgetKey?: string;
    widgetConfig?: TConfig;
}
